import React from "react";

export default function CommunityGuidelines() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <h1>Community Guidelines</h1>
      <p>Help keep GhanaDating safe, respectful, and fun.</p>

      <h2>Adults only (18+)</h2>
      <p>No under-18 users. Accounts suspected to be under 18 will be removed.</p>

      <h2>Be respectful</h2>
      <ul>
        <li>No harassment, bullying, threats, or hate speech.</li>
        <li>No pressure, coercion, or non-consensual sexual content.</li>
      </ul>

      <h2>No scams or impersonation</h2>
      <ul>
        <li>No fraud, fake identities, or pretending to be someone else.</li>
        <li>No phishing links or attempts to steal accounts/money.</li>
      </ul>

      <h2>No compensated dating / prohibited services</h2>
      <ul>
        <li>No escorting, prostitution, “sugar” arrangements, or paid meetups.</li>
        <li>
          No content suggesting dating/sex in exchange for money, gifts, or
          support.
        </li>
      </ul>

      <h2>Report & block</h2>
      <p>
        Use Block and Report if someone behaves badly. We may remove content and
        ban accounts that violate these rules.
      </p>
    </main>
  );
}